<div class="wrapper">
  <div class="">
    <div class="container-fluid">
      <div class="row" *ngIf="isPayment">
        <div class="col-xl-12 col-12 m-auto">
          <div class="card rounded shadow-lg">
            <div class="card-header headerbg" style="border-bottom: 3px solid #d8eff8">
              <h5 class="mb-0">Payment</h5>
            </div>
            <div class="card-body">
              <div *ngIf="!isPaymentVisible">
                <div class="form-group row">
                  <label class="col-md-5 control-label line_2 rem_1">
                    Institution Name :
                    <span class="text-danger">*</span></label>
                  <div class="col-md-7 inputGroupContainer">
                    <div class="input-group">
                      <!-- <strong>:</strong> &nbsp; -->
                      <input type="text" placeholder="" [(ngModel)]="userInfo.clientName" disabled
                        class="form-control shadow-sm rounded-lg"
                        onkeypress="return ((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode == 8 || event.charCode == 32 || (event.charCode >= 48 && event.charCode <= 57));" />
                    </div>
                  </div>
                </div>
                <div class="form-group row pt-4">
                  <label class="col-md-5 control-label line_2 rem_1">
                    Amount : <span class="text-danger">*</span></label>
                  <div class="col-md-7 inputGroupContainer">
                    <div class="input-group">
                      <!-- <strong>:</strong> &nbsp; -->
                      <input type="text" placeholder="" [(ngModel)]="formattedAmount"
                        (ngModelChange)="formattedAmount = $event" disabled class="form-control shadow-sm rounded-lg"
                        onkeypress="return ((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode == 8 || event.charCode == 32 || (event.charCode >= 48 && event.charCode <= 57));" />
                    </div>
                  </div>
                </div>
                <!-- <div class="form-group row pt-4">
            <label class="col-md-5 control-label line_2 rem_1">
              Mobile Number
              <span class="text-danger">*</span></label
            >
            <div class="col-md-7 inputGroupContainer">
              <div class="input-group">
                <strong>:</strong> &nbsp;
                <input
                  type="text"
                  placeholder=""
                  [(ngModel)]="userInfo.clientMobile"
                  disabled
                  class="form-control shadow-sm rounded-lg"
                  onkeypress="return ((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode == 8 || event.charCode == 32 || (event.charCode >= 48 && event.charCode <= 57));"
                />
              </div>
            </div>
          </div> -->
                <div class="form-group row pt-4">
                  <label class="col-md-5 control-label line_2 rem_1">
                    Currency : <span class="text-danger">*</span></label>
                  <div class="col-md-7 inputGroupContainer">
                    <div class="input-group">
                      <!-- <strong>:</strong> &nbsp; -->
                      <input type="text" placeholder="" [(ngModel)]="userInfo.CURRENCY" disabled
                        class="form-control shadow-sm rounded-lg"
                        onkeypress="return ((event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode == 8 || event.charCode == 32 || (event.charCode >= 48 && event.charCode <= 57));" />
                    </div>
                  </div>
                </div>

                <div class="form-group row pt-4 d-none">
                  <label class="col-md-5 control-label">Service name :<span class="text-danger">*</span></label>
                  <div class="col-md-7 inputGroupContainer">
                    <div class="input-group">
                      <!-- <strong>:</strong> &nbsp; -->
                      <select [(ngModel)]="serviceName" class="form-control shadow-sm rounded-lg" id="sel1">
                        <option value="">Select</option>
                        <option *ngFor="let item of servicesbyCurrency" [value]="item.pg_services_id">
                          {{ item.pg_service_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="float-end mt-4">
                  <button type="button" (click)="back()" class="btn btn-danger">
                    Back</button>&nbsp;&nbsp;
                  <button type="button" (click)="Submit()" class="btn btn-success">
                    Submit
                  </button>
                </div>
              </div>
              <div *ngIf="isPaymentVisible" style="overflow: auto">
                <iframe id="postFrame" name="postFrame" width="100%" height="600"></iframe>
                <!-- <div id="pamentContent"></div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <section class="phx-hero">
    <form #form action="https://payments.ecitizen.go.ke/PaymentAPI/iframev2.1.php" method="post" target="my_iframe">
      <input type="hidden" id="secureHash" [value]="userInfo.HashKey" name="secureHash" />
      <input type="hidden" name="apiClientID" [value]="userInfo.apiClientId" />
      <input type="hidden" class="form-control" id="serviceID" name="serviceID" [value]="userInfo.serviceId" />
      <input type="hidden" class="form-control" id="notificationURL" name="notificationURL"
        [value]="userInfo.NotificationUrl" />
      <input type="hidden" class="form-control" id="callBackURLOnSuccess" name="callBackURLOnSuccess"
        [value]="userInfo.callBackURLOnSuccess" />
      <input type="hidden" class="form-control" id="billRefNumber" name="billRefNumber"
        [value]="userInfo.billRefNumber" />
      <input type="hidden" class="form-control" id="accountNumber" name="sendSTK" value="false" />
      <input type="hidden" class="form-control" id="pictureURL" name="pictueURL"
        value="https://posthere.io/2307-0310-4237/" />
      <input type="hidden" class="form-control" id="format" name="format" value="iframe" />
      <input type="hidden" class="form-control" id="currency" name="currency" [value]="userInfo.CURRENCY" />
      <input type="hidden" class="form-control" id="amountExpected" name="amountExpected" [value]="userInfo.amount" />
      <input type="hidden" class="form-control" id="billDesc" name="billDesc" [value]="userInfo.billdesc" />
      <input type="hidden" class="form-control" id="clientMSISDN" name="clientMSISDN" value="" />
      <input type="hidden" class="form-control" id="clientIDNumber" name="clientIDNumber"
        [value]="userInfo.clientidnumber" />
      <input type="hidden" class="form-control" id="clientEmail" name="clientEmail" [value]="userInfo.UserName" />
      <input type="hidden" class="form-control" id="clientName" name="clientName" [value]="userInfo.clientName" />
      <button type="submit" class="btn btn-primary" id="payButton" style="display: none" (click)="form.submit()"
        value="Submit">
        Make Payment
      </button>
    </form>
  </section>
  <section class="phx-hero">
    <iframe name="my_iframe" id="my_iframe" width="100%" height="1000px" frameborder="0" scrolling="auto"></iframe>
  </section>

  <script>
    iframe.contentDocument.open();
    iframe.contentDocument.write(responseHTML);
    iframe.contentDocument.close();
  </script>



  <div class="modal" id="myModal" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-s">
      <div class="modal-content">
       
        <div class="modal-body">
          <form class="well form-horizontal" [formGroup]="myForm" (ngSubmit)="onSubmit(myForm)">
            <fieldset>
              <div class="row">
                <div>
                  <label class="form-label">Thank you for submitting your application. Our team will verify the
                    application and act accordingly. Check your email for updates</label>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-success" (click)="okButton()">
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>